export const ROUTE_STATE_KEY = 'routes';
export const LANGUAGE_KEY = 'language';
export const REMEMBERED_MAIL_KEY = 'rememberedMail';
export const CONTEXT_DATA_KEY = 'contextData';

export const SYSTEM_CODE = 'Commencement';
export const SYSTEM_GROUP_CODE = 'Core';

export const SYSTEM_NAME = 'Commencement';
export const DEFAULT_LANGUAGE = 'en-us';
